module.exports = __webpack_public_path__ + "img/camera-img.76ae8d7a.svg";